import React from "react";
import { useTranslation } from 'react-i18next';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

import Copyright from '../../Copyright/Copyright'

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Verify(props){
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Avatar className={classes.avatar} src="logo.png" />
        <Typography variant="h5">
          {t('Verify')}
        </Typography>
        <form className={classes.form} noValidate onSubmit={props.handleVerify}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                name="challengeAnswer"
                variant="outlined"
                required
                fullWidth
                id="challengeAnswer"
                type="tel"
                label={t('FormLabels.VerifyResponse')}
                autoFocus
                value={props.challengeAnswer}
                onChange={e => props.setChallengeAnswer(e.target.value)}
                error={props.challengeAnswerWrong}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">{t('FormLabels.CodeSent')}</Typography>
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={props.loading}
          >
            {t('Login').toUpperCase()}
            &nbsp;
            {props.loading && <CircularProgress size={24}/>}
          </Button>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
    );

}
